import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { HomePageService } from './home-page.service';

@Injectable({
  providedIn: 'root',
})
export class HomePageRedirectGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private homePageService: HomePageService,
    private router: Router
  ) {}

  /**
   * Redirect root path (/) to user-specific home page
   * Determines the appropriate home page for the authenticated user and redirects
   * @returns UrlTree - Returns redirect to user's home page
   */
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const currentUser = this.authService.currentUserValue;

    console.log('HomePageRedirectGuard: Checking home page redirect', { 
      currentUser: currentUser?.email, 
      url: state.url 
    });

    // If not authenticated, return true and let other guards handle it
    if (!currentUser || !currentUser.email) {
      console.warn('HomePageRedirectGuard: No authenticated user found');
      return true;
    }

    // Check if user's email is expired
    if (currentUser.expiredAt && currentUser.expiredAt * 1000 < new Date().getTime() + 1) {
      console.warn('HomePageRedirectGuard: User session expired');
      return true;
    }

    // Get the home page for this user
    const homePage = this.homePageService.getHomePageForUser(currentUser.email.toLowerCase());
    
    console.log(`HomePageRedirectGuard: Redirecting user '${currentUser.email}' from '${state.url}' to home page: '${homePage}'`);
    
    // Return the redirect URL
    return this.router.parseUrl(homePage);
  }
}
